import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import SearchPageHeader from 'bundles/composable-page-header-consumer/header-renderers/SearchPageHeader';
import UniversalPageFeatures from 'bundles/composable-page-header/components/UniversalPageFeatures';
import PageFooter from 'bundles/page-footer/components/PageFooter';

import 'css!../__styles__/index';

const SeoSearchApp: React.LegacyFunctionComponentWithChildren = ({ children }) => (
  <div className="rc-SeoSearchApp">
    <UniversalPageFeatures />
    <SearchPageHeader />
    {children}
    <PageFooter />
  </div>
);

export default compose<{}, {}>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'seo_entity_page',
      page: 'search',
    },
  }))
)(SeoSearchApp);
